export default {
  PleaseLoginFirst: '请先登录',
  IdentityExpired: '身份过期，请重新登录',
  InsufficientBalance: '您的余额不足，请点击右上角头像，前往 "我的账户" 查看',
  ImageGenerationFailed: '图片生成失败，请检查提示词参数或内容',
  TaskNotFound: '作图任务未找到，请重试或联系客服处理',
  ServiceUnavailable: '当前服务不可用，请重试或联系客服处理',
  PleaseWaitForCurrentTask: '请耐心等待当前任务完成',
  ImageGenerationIssue: '图片生成遇到了一点小问题，请重试一下吧',
  UnknownError: '未知异常，请重试或联系客服处理',
  NetworkIssue: '网络遇到一些问题，请点击刷新，或联系客服处理~',
  Refresh: '刷新',
  RequestCancelled: '请求被取消'
}